module.exports = __webpack_public_path__ + "img/icone_zip.2d4082db.png";